<template>
  <div class="major">
    <div class="banner">
      <img
        src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/banner123.jpg"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="p1">
      <bigtitle title="西点西餐全方位教学培训"></bigtitle>
      <middletitle title="四大热门专业选择，条条大路通罗马"></middletitle>
      <div
        style="width: 200px; height: 4px; margin: auto; background: #8d6e63"
      ></div>
      <div class="head">
        <div class="head-one" v-for="data in headList" :key="data.id">
          <div class="head-one-img">
            <img :src="data.img" alt="" />
          </div>
          <div class="head-one-title">
            <h2>{{ data.title }}</h2>
          </div>
          <div class="head-one-button"> <a href="javascript:void(0)" onclick="ydtopenchat();return false;">
            <md-button class="md-raised md-accent" style="width:200px">了解更多</md-button></a>
          </div>
        </div>
      </div>
    </div>
    <div class="back">
      <div class="back-one">
        <div style="width: 100%; height: 250px"></div>
        <div class="back-one-insite"></div>
      </div>
    </div>
    <div class="p2">
      <div class="type">
        <div class="type-title">
          <bigtitle title="热门专业课程"></bigtitle>
          <middletitle title="多种课程设置，满足不同需求"></middletitle>
        </div>
        <div style="width:100%;height:90px"></div>
        <div class="type-img">
          <img src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/p1.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="foot-title">
         <h1 style="color:#fff">大师之道 精益求精</h1>
      <h2 style="color:#fff">Master's way, keep improving </h2>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
    bigtitle: () => import("@/components/common/bigTitle"),
    middletitle: () => import("@/components/common/middletitle"),
    // buttongroup: () => import("@/components/common/buttongroup"),
  },
  data() {
    return {
      headList: [
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/head1.png",
          title: "烘焙甜点专业",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/head2.png",
          title: "西餐料理专业",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/head3.png",
          title: "咖啡饮品专业",
        },
        {
          img: "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/head4.png",
          title: "精品调酒专业",
        },
      ],
    };
  },
    mounted() {
    window.scroll(0, 0);
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  margin-top: 64px;
}
.p1 {
  width: 100%;
  padding: 16px 0;
  height: 100%;
  background: #f0f5ff;
}
.head {
  width: 1200px;
  height: 430px;
  padding: 48px 0 24px 0;
  margin: auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.head-one {
  width: 300px;
  height: 300px;
}
.head-one-img {
  width: 100%;
  text-align: center;
  height: 240px;
}
.head-one-title {
  width: 100%;
  padding: 16px 0;
}
.back {
  width: 100%;
  height: 330px;
  background-image: url("https://cdomick.oss-cn-shenzhen.aliyuncs.com/newpc/major/b1.jpg");
}
.back-one {
  width: 100%;
  height: 80px;
}
.back-one-insite {
  width: 1200px;
  margin: auto;
  background: #fff;
  height: 80px;
}
.p2 {
  width: 100%;
  height: 100%;
  padding: 0 0 70px 0;
  background: #eee;
}
.type {
  width: 1200px;
  margin: auto;
  background: #fff;
  height: 2000px;
  position: relative;
}
.type-title {
  width: 1200px;
  position: absolute;
  top: -60px;
}
.foot{
  width: 100%;
  height: 250px;
  padding: 90px 0 0 0;
  background:#8d6d63;
}
.foot-title{
  width: 100%;
  height: 100px;
}
</style>